import {
    Skeleton as PrimeReactSkeleton,
    SkeletonProps as PrimeReactSkeletonProps,
} from "primereact/skeleton";
import { classNames } from "primereact/utils";

interface SkeletonProps {}

const Skeleton = (props: PrimeReactSkeletonProps & SkeletonProps) => {
    const { className, ...rest } = props;

    return (
        <PrimeReactSkeleton
            {...rest}
            className={classNames("bg-secondary-500/10", className)}
        />
    );
};

export default Skeleton;
